export interface LoginErrorView {
  /** Translation key for the toast title. Literal, so i18next's typed keys still check. */
  titleKey: 'twoFactor.cooldown' | 'messages.loginFailed'
  /** Server-supplied text, already human-readable. Preferred over detailKey when present. */
  detail?: string
  /** Translation key to fall back to when the server sent no text. */
  detailKey?: 'messages.invalidCredentials'
}

/**
 * Decide how a failed POST /api/auth/login should read to the user.
 *
 * #192: the page used to read `detail` only and always fall back to "invalid credentials".
 * The 2FA paths answer `{error: ...}`, so a rate-limited superuser was told their password
 * was wrong. A 429 is a wait, never a credential failure — it arrives either as the per-IP
 * throttle (`detail`) or as the 2FA hourly code ceiling (`error`, with a Retry-After header).
 */
export function presentLoginError(
  status: number | undefined,
  data?: { detail?: string; error?: string },
): LoginErrorView {
  const detail = data?.detail ?? data?.error

  if (status === 429) {
    return { titleKey: 'twoFactor.cooldown', detail }
  }

  return { titleKey: 'messages.loginFailed', detail, detailKey: 'messages.invalidCredentials' }
}
